import React, { ReactNode } from "react";
import {useEffect, createContext, useReducer } from "react";
import Reducer from "./Reducers";
import { UserProps } from '../types/types'


interface Props {
    children?: ReactNode
}
interface ContextTypeProps {
    user: {
      password: string;
        _id?: any;username?: string, bio?: string, email?: string, profilePic?: string
},
    isFetching: boolean,
    error: boolean,
    dispatch?: any
}

const INITIAL_STATE = {
    user: JSON.parse(localStorage.getItem('user') || "null"),
    isFetching: false,
    error: false
}

export const Context = createContext<ContextTypeProps>(INITIAL_STATE);

export const ContextProvider = ({children}: Props) => {
    const [state, dispatch] = useReducer(Reducer, INITIAL_STATE);

    useEffect(() => {
        localStorage.setItem("user", JSON.stringify(state.user));
    },[state.user])

    return (
        <Context.Provider value={{
                user: state.user,
                isFetching: state.isFetching,
                error: state.error,
                dispatch,
            }}
        >
            {children}
        </Context.Provider>
    )
}